



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CounterList from '@/components/counters/CounterList.vue';
import { namespace } from 'vuex-class';
import { Resource } from '@/modules/backend/Entities/Resource';

const AuthModule = namespace('app/auth');

@Component({
  components: {
    'counter-list': CounterList
  }
})
export default class CounterFilteredList extends Vue {
  @Prop({ required: true })
  private readonly accountId!: number;

  @AuthModule.Getter('Resources')
  private readonly authResources!: Resource[];

  @Prop({
    required: false,
    default: false,
    type: Boolean
  })
  private readonly filtered!: boolean;

  private get resources(): number[] {
    if (!this.filtered) {
      return [];
    }

    return this.authResources.map((resource: Resource): number => resource.getId());
  }
}
